<script>
  import {
    ChevronsLeftIcon,
    ChevronsRightIcon,
  } from 'vue-feather-icons'

  export default {
    components: {
      ChevronsLeftIcon,
      ChevronsRightIcon,
    },
    props: {
      tabItems: {
        type: Array,
        required: true,
      },
      initActiveTab:{
        type: String,
        default: 'dashboard'
      },
    },
    data(){
      return {
        activeTab: '',
        hover: false,
        isHoverDirectionRight: false,
        repeaterId: null,
        mobileCheckerId: null,
        initialTabOffset: 0,
        tabOverflow: false,
        windowWidth: 0,
        disableLeft: false,
        disableRight: false,
        oldLeftVal: 0,
      }
    },
    computed:{
      tabTotals(){
        if (this.tabItems){
          return this.tabItems.length
        }
        return 0
      },
      tabIndex(){
        if (this.activeTab && this.tabItems){
          return this.tabItems.findIndex(el => el.tab === this.activeTab)
        }
        return 0
      },
      innerWidth(){
        let retval = 0
        if (this.$refs){
          let refObject = this.$refs.panableNavs
          if (!this.isMobile){
            refObject = this.$refs.desktopTabs
          }
          for (const tab of refObject.children) {
            retval += tab.offsetWidth
          }
        }
        return retval
      },
      tabOffset(){
        if (this.$refs){
          if (this.isMobile && this.$refs.panableNavs.childElementCount > 3){
            return this.$refs.panableNavs.children[0].offsetWidth * this.tabIndex
          }
          if (!this.isMobile && this.$refs.desktopTabs.childElementCount > 3){
            return this.$refs.desktopTabs.children[0].offsetWidth * this.tabIndex
          }
        }
        return 0
      },
      isMobile(){
        return this.windowWidth < 768
      },
      panInterval(){
        if (this.isMobile){
          return 50
        }
        return 10
      },
    },
    watch: {
      windowWidth(newVal, oldVal){
        const tabsObject = this.$refs.desktopTabs
        if (tabsObject && tabsObject.childElementCount > 1){
          this.$set(this, 'tabOverflow', (tabsObject.offsetWidth - 35) < (tabsObject.childElementCount * tabsObject.children[0].offsetWidth))
        }else{
          this.$set(this, 'tabOverflow', false)
        }
      },
      hover(newVal, oldVal){
        if(newVal){
          this.repeaterId = setInterval(this.panObject, this.panInterval)
        }else{
          clearInterval(this.repeaterId)
          this.repeaterId = null
        }
      },
    },
    created(){
      this.activeTab = this.initActiveTab

      this.windowWidth = window.innerWidth
      window.addEventListener('resize', () => {
        this.windowWidth = window.innerWidth
      });
    },
    mounted(){
      if (this.$refs) {
        if (this.isMobile && this.$refs.panableNavs && this.$refs.panableNavs.childElementCount > 3){
          const panRef = this.$refs.panableNavs
          panRef.scrollLeft = (panRef.scrollLeft + this.tabOffset - 25)
        } else if(this.$refs.desktopTabs && this.$refs.desktopTabs.childElementCount > 3){
          this.$nextTick(() => {
            const panRef = this.$refs.desktopTabs
            panRef.scrollLeft = (panRef.scrollLeft + this.tabOffset - 25)
          });
        }
        this.bindRefWatches()
      }
    },
    beforeDestroy(){
      if(this.isMobile){
        if(this.mobileCheckerId !== null){
          clearInterval(this.mobileCheckerId)
        }
      }
    },
    methods:{
      bindRefWatches(){
        if(this.isMobile){
          if(this.mobileCheckerId !== null){
            clearInterval(this.mobileCheckerId)
          }
          this.mobileCheckerId = setInterval(this.checkMobileAtEdge, this.panInterval * 2)
        }
      },
      checkMobileAtEdge(){
        if (!this.isMobile){
          clearInterval(this.mobileCheckerId)
          this.mobileCheckerId = null
          return
        }
        const newVal = this.$refs.panableNavs.scrollLeft;
        const rightEndIndex = this.$refs.panableNavs.offsetWidth + this.$refs.panableNavs.scrollLeft

        if (newVal === 0){
          // far left
          this.disableLeft = true
        }else if(this.oldLeftVal === newVal && rightEndIndex >= this.innerWidth){
          // far right
          this.disableRight = true
        }else{
          // neither edge
          this.disableRight = false
          this.disableLeft = false
        }

        this.oldLeftVal = newVal
      },
      activateTab(tabItem){
        if (tabItem && Object.prototype.hasOwnProperty.call(tabItem, 'routeObject')){
          this.$router.push(tabItem.routeObject)
        } else {
          this.setActiveTab(tabItem.tab)
        }
        clearInterval(this.mobileCheckerId)
      },
      setActiveTab(tabKey){
        this.$set(this, 'activeTab', tabKey)
      },
      resolveId(index){
        return `mob-tab-nav-${index}`
      },
      panObject(){
        if (!this.hover){
          clearInterval(this.repeaterId)
          this.repeaterId = null
          return
        }
        let panRef;
        if (this.isMobile){
          panRef = this.$refs.panableNavs
        }else{
          panRef = this.$refs.desktopTabs
        }
        if (panRef){
          const oldVal = panRef.scrollLeft;
          if(this.isHoverDirectionRight){
            panRef.scrollLeft += 2
          }else{
            panRef.scrollLeft -= 2
          }
          if (oldVal === panRef.scrollLeft){
            if (oldVal === 0){
              this.disableLeft = true
            }
            if(this.isHoverDirectionRight){
              this.disableRight = true
            }
          }else{
            this.disableRight = false
            this.disableLeft = false
          }
        }
      },
    }
  }
</script>

<template>
  <div
    class="
    tabs custom-tab ovf-v
    tw-border-0 md:tw-border tw-rounded-none md:tw-rounded-20
    tw-bg-white
    tw-mx-[-19px] md:!tw-mx-0">
    <section
      class="nav nav-tabs border-radius-t-20
      tw-hidden md:tw-flex md:tw-flex-nowrap
      tw-cursor-pointer tw-text-center">
      <div
        v-if="tabOverflow"
        class="tw-z-20 tw-w-1/12 tw-inline-flex tw-justify-center tw-items-center
        bg-blend-color tw-bg-gradient-to-r tw-from-gray-300 tw-to-gray-100
        tw-rounded-tl-20"
        :class="{
          'tw-text-gray-500 tw-cursor-default': disableLeft,
          'tw-text-primary': !disableLeft,
        }"
        @mouseover="hover = true; isHoverDirectionRight = false"
        @mouseleave="hover = false">
        <ChevronsLeftIcon/>
      </div>
      <section
        ref="desktopTabs"
        class="
          tw-z-10 tw-overflow-x-scroll scroll-hidden
          tw-flex tw-flex-row tw-flex-nowrap
          tw--mb-px"
        :class="{
          'tw-w-full': !tabOverflow,
          'tw-w-10/12': tabOverflow,
        }">
        <article
          v-for="(item, index) in tabItems"
          :key="`tab-${index}`"
          class="
            tw-flex tw-items-center tw-justify-center tw-text-center
            tw-h-12 tw-py-px
            tw-border-r"
          :class="{
            'active tw-border-b-0': activeTab === item.tab,
            'border-radius-tl-20': index === 0,
            '!tw-bg-white !tw-border-b-white shadow-border-b-2-white tw-cursor-default': activeTab === item.tab,
          }">
          <span
            v-if="item.available"
            class="tw-h-full tw-w-full tw-flex tw-items-center tw-text-center"
            @click="activateTab(item)">
            <article
              class="nav-link !tw-py-0 !tw-px-4 tw-min-w-[6.5rem] tw-min-h-6 tw-inline-flex tw-justify-center !tw-items-center !tw-border-0"
              :class="{
                'active !tw-bg-white !tw-border-b-white tw-pointer-events-none': activeTab === item.tab,
                'hover:tw-text-primary': activeTab !== item.tab,
              }"
            >{{ item.title }}<span
              v-if="item.enableCounts && (!!item.counts || item.counts === undefined)"
              class="pd-l-10"
              :class="{
                'tw-hidden': item.counts <= 0,
              }" >
              <svg
                :class="item.counts > 0 ? 'v-v fade-in' : 'v-h'"
                height="22"
                width="22"
                class="nav-counts">
                <circle
                  cx="11"
                  cy="11"
                  r="11"
                  fill="#CED8E1" />
                <text
                  x="50%"
                  y="50%"
                  text-anchor="middle"
                  dy=".33em">{{ item.counts }}</text>
              </svg>
            </span></article>
          </span>
        </article>
      </section>
      <div
        v-if="tabOverflow"
        class="tw-z-20 tw-w-1/12 tw-inline-flex tw-justify-center tw-items-center
          bg-blend-color tw-bg-gradient-to-l tw-from-gray-300 tw-to-gray-100 tw-pl-1
          tw-rounded-tr-20"
        :class="{
          'tw-text-gray-500 tw-cursor-default': disableRight,
          'tw-text-primary': !disableRight,
        }"
        @mouseover="hover = true; isHoverDirectionRight = true"
        @mouseleave="hover = false">
        <ChevronsRightIcon/>
      </div>
    </section>
    <section
      class="
      nav nav-tabs border-radius-t-20
      tw-flex md:tw-hidden tw-flex-row
      tw- tw-border-r-0 tw-h-12 tw-w-full">
      <div
        v-if="tabTotals > 3"
        class="tw-z-20 tw-w-1/12 tw-inline-flex tw-justify-center tw-items-center
        bg-blend-color tw-bg-gradient-to-r tw-from-gray-300 tw-to-gray-100
        tw-border-b tw-border-b-gray-400 tw-border-t tw-border-t-gray-100 tw-rounded-tl-20"
        :class="{
          'tw-text-gray-500 tw-cursor-default': disableLeft,
          'tw-text-primary': !disableLeft,
        }"
        @mouseover="hover = true; isHoverDirectionRight = false"
        @mouseleave="hover = false">
        <ChevronsLeftIcon />
      </div>
      <section
        ref="panableNavs"
        class="
          tw-z-10 tw-overflow-x-scroll scroll-hidden
          tw-flex tw-flex-row tw-flex-nowrap
          tw-touch-pan-x
          tw-bg-gray-100"
        :class="{
          'tw-w-full': tabTotals <= 3,
          'tw-w-10/12': tabTotals > 3,
        }">
        <div
          v-for="(item, index) in tabItems"
          :id="resolveId(index)"
          :key="`tab-mob-${index}`"
          class="
            tw-flex tw-justify-center tw-items-center
            tw-border-b tw-border-t tw-border-gray-400 tw-rounded-20 !tw-rounded-b-none
            tw-text-center
            tw-px-2"
          :class="{
            'tw-border-l': index !== 0,
            'tw-bg-white tw-text-black tw-border-b-white tw-cursor-default tw-pointer-events-none': activeTab === item.tab,
            'tw-bg-gray-100 tw-text-primary tw-cursor-pointer': activeTab !== item.tab,
            'tw-min-w-2/5 tw-w-2/5': tabTotals > 3,
            'tw-min-w-1/3 tw-w-1/3': tabTotals === 3,
            'tw-min-w-[50%] tw-w-1/2': tabTotals === 2,
            'tw-min-w-full tw-w-full': tabTotals < 2,
            'tw-border-r': index + 1 === tabTotals,
          }"
          @click="activateTab(item)">
          {{ Object.prototype.hasOwnProperty.call(item, 'shortTitle') ? item.shortTitle : item.title }}
          <span
            v-if="item.enableCounts && (!!item.counts || item.counts === undefined)"
            class="pd-l-10"
            :class="{
              'tw-hidden': item.counts <= 0,
            }" >
            <svg
              :class="item.counts > 0 ? 'v-v fade-in' : 'v-h'"
              height="22"
              width="22"
              class="nav-counts">
              <circle
                cx="11"
                cy="11"
                r="11"
                fill="#CED8E1" />
              <text
                x="50%"
                y="50%"
                text-anchor="middle"
                dy=".33em">{{ item.counts }}</text>
            </svg>
          </span>
        </div>
      </section>
      <div
        v-if="tabTotals > 3"
        class="tw-z-20 tw-w-1/12 tw-inline-flex tw-justify-center tw-items-center
          bg-blend-color tw-bg-gradient-to-l tw-from-gray-300 tw-to-gray-100 tw-pl-1
          tw-border-b tw-border-b-gray-400 tw-border-t tw-border-t-gray-100 tw-rounded-tr-20"
        :class="{
          'tw-text-gray-500 tw-cursor-default': disableRight,
          'tw-text-primary': !disableRight,
        }"
        @mouseover="hover = true; isHoverDirectionRight = true"
        @mouseleave="hover = false">
        <ChevronsRightIcon />
      </div>
    </section>
    <div class="tab-content tw--mt-0.5 md:tw-mt-4 tw-bg-white md:tw-rounded-20">
      <slot name="tab-details" :active-tab="activeTab"/>
    </div>
  </div>
</template>
